export class IPayerType
{
    payerTypeId:number;
    payerTypeCode:string;
    payerTypeName:string;
    isActive:boolean;
    sourceId:string;
}
